'use strict';
const assert = require('assert');
const Customer = require('../customer');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const expect = chai.expect;
/* eslint-disable no-undef, no-unused-vars */
describe('Customer', () => {
  it('getProfile, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.byId('23124').get()
      .then((result) => {
        assert(result.method === 'GET');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers/23124');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
      })
      .then(done, done);
  });
  it('getProfile, must have customerId', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    try {
      customer.get();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the customerId');
      done();
    }
  });
  it('getCompanyProfile, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.byId('23124').getCompanyProfile()
      .then((result) => {
        assert(result.method === 'GET');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers/23124/profiles/company');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
      })
      .then(done, done);
  });
  it('getCompanyProfile, must have customerId', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    try {
      customer.getCompanyProfile();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the customerId');
      done();
    }
  });
  it('getBillingProfile, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.byId('23124').getBillingProfile()
      .then((result) => {
        assert(result.method === 'GET');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers/23124/profiles/billing');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
      })
      .then(done, done);
  });
  it('getBillingProfile, must have customerId', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    try {
      customer.getBillingProfile();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the customerId');
      done();
    }
  });
  it('list, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.byId('23124').list(3)
      .then((result) => {
        assert(result.method === 'GET');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers?size=3');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
      })
      .then(done, done);
  });
  it('search, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.search(3, {
      Field: 'Domain',
      Value: 'Kanek',
      Operator: 'starts_with',
    })
      .then((result) => {
        assert(result.method === 'GET');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers?size=3&filter=%7B%22Field%22%3A%22Domain%22%2C%22Value%22%3A%22Kanek%22%2C%22Operator%22%3A%22starts_with%22%7D');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
      })
      .then(done, done);
  });
  it('create, create the request successfully', (done) => {
    const fakeRequest = options => Promise.resolve(options);
    const credentials = {
      domain: 'csDesarrollo.onmicrosoft.com',
      clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
      userName: 'app@csDesarrollo.onmicrosoft.com',
      password: 'Inn0vaci0n',
    };
    const CompanyProfile = {
      Domain: 'tasitademodulo.onmicrosoft.com',
    };
    const BillingProfile = {
      FirstName: 'firstName',
      LastName: 'lastName',
      Email: 'email@sample.com',
      Culture: 'ES-MX',
      Language: 'ES',
      CompanyName: 'Module Test',
      DefaultAddress: {
        Country: 'MX',
        City: 'Guadalajara',
        State: 'JA',
        AddressLine1: '1 Microsoft Way',
        PostalCode: '98052',
        FirstName: 'FirstName',
        LastName: 'LastName',
        PhoneNumber: '4255555555',
      },
    };
    const customer = new Customer(credentials, fakeRequest, sdkConfiguration);
    customer.byId('23124').create(CompanyProfile, BillingProfile)
      .then((result) => {
        assert(result.method === 'POST');
        assert(result.uri === 'https://api.partnercenter.microsoft.com/v1/customers');
        assert(result.headers.Accept === 'application/json');
        assert(result.headers['Content-Type'] === 'application/json');
        expect(result.headers).to.have.property('MS-RequestId');
        expect(result.headers).to.have.property('MS-CorrelationId');
        expect(result).to.have.property('body');
        expect(result.body).to.have.property('CompanyProfile');
        expect(result.body).to.have.property('BillingProfile');
        expect(result.body.CompanyProfile).to.have.property('Domain');
        expect(result.body.BillingProfile).to.have.property('FirstName');
        expect(result.body.BillingProfile).to.have.property('LastName');
        expect(result.body.BillingProfile).to.have.property('Email');
        expect(result.body.BillingProfile).to.have.property('Culture');
        expect(result.body.BillingProfile).to.have.property('Language');
        expect(result.body.BillingProfile).to.have.property('CompanyName');
        expect(result.body.BillingProfile).to.have.property('DefaultAddress');
      })
      .then(done, done);
  });
});
